module.exports = __webpack_public_path__ + "static/media/IMG_1333.8a6e0013.jpg";